import React, { Component } from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';

// components
import PrescriptionsFlags from 'manage/PrescriptionsFlags';
import OptionsMenu from 'manage/OptionsMenu';
import SeedRateThumbnail from 'dataviz/SeedRateThumbnail';
import Name from 'manage/Name';
import Timestamp from 'manage/Timestamp';
import SeedSummary from 'manage/SeedSummary';
import JohnDeereWorkPlan from 'manage/JohnDeereWorkPlan';

// Selectors
import { getActiveScriptId, scriptOptionsIsOpenForScriptId } from 'current/selectors';
import { canManualScript } from 'product-features/selectors';
import { getCropIdForScript, isAdvancedScript, isDisplayPrimaryScript, getCropForScript, getBagSizeForScript
} from 'scripts/selectors';
import { getManageSeedSummary } from 'scripts/planting-selectors';
import { getProductValidationValues, getBagSizeForCrop, getAccountCountry } from 'user/selectors';

// Actions
import { setScriptOptionsIsOpen } from 'current/uiwidgets/';
import { editScript } from 'scripts';
import { requestDriveDevices, requestPreferredDevice } from 'devices/requesters';
import { requestAffiliateList } from 'affiliates/requesters';

// Util
import isEqual from 'lodash/isEqual';

import { trackAction } from 'util/analytics';

const baseString = 'vra-prescription-card';
class PlantingScriptCardContainer extends Component {

  shouldComponentUpdate(nextProps, nextState) {
    return !isEqual(this.props, nextProps) || !isEqual(this.state, nextState);
  }

  render() {
    const {
      accountCountry,
      bagSize,
      canManualScript,
      cropId,
      isSelected,
      onClickEditTrigger,
      onClickScriptOptionsTrigger,
      onSelectScript,
      productValidationValues,
      script,
      scriptId,
      scriptOptionsIsOpen,
      seedSummary,
      showPrimaryFlag
    } = this.props;

    const classString = classNames({
      [baseString]: true,
      'isSelected': isSelected,
    });
    const dataTestId = showPrimaryFlag ? 'script-primary' : 'script-not-primary';

    const onClickContainer = () => {
      trackAction(`Clicked on a planting script on the left panel', Rx:${scriptId}`);
      onSelectScript(scriptId);
    };
    const onClickOptions = () => onClickScriptOptionsTrigger({ scriptId, currentStatus: scriptOptionsIsOpen });

    return (
      <div onClick={onClickContainer}>
        <div className={classString} data-test-id={baseString}>
          <PrescriptionsFlags
            createdAt={script['create-time']}
            isPrimary={showPrimaryFlag}
            programInstanceId={script['program-instance-id']}
          />
          <div className={`${baseString}__identification-section`}>
            <SeedRateThumbnail productValidationValues={productValidationValues} script={script} />
            <div className={`${baseString}__name-section`}>
              <Name
                canManualScript={canManualScript}
                isSelected={isSelected}
                name={script.name}
                onClickEditTrigger={onClickEditTrigger}
                scriptId={scriptId}
              />
              <Timestamp timestamp={script['update-time']} />
            </div>
            <OptionsMenu
              onClick={onClickOptions}
              scriptOptionsIsOpen = {scriptOptionsIsOpen}
            />
          </div>
          <section className={`${baseString}__content-wrapper`} data-test-id={dataTestId}>
            <SeedSummary accountCountry={accountCountry}
              bagSize={bagSize}
              cropId={cropId}
              summary={seedSummary}
            />
          </section>
        </div>
        <JohnDeereWorkPlan isSelected={isSelected} scriptId={scriptId} />
      </div>
    );
  }
}

PlantingScriptCardContainer.propTypes = {
  accountCountry: propTypes.string.isRequired,
  bagSize: propTypes.number.isRequired,
  canManualScript: propTypes.bool.isRequired,
  cropId: propTypes.number,
  isAdvancedScript: propTypes.bool.isRequired,
  isSelected: propTypes.bool.isRequired,
  onClickEditTrigger: propTypes.func,
  onClickScriptOptionsTrigger: propTypes.func,
  onSelectScript: propTypes.func,
  productValidationValues: propTypes.object,
  script: propTypes.object,
  scriptId: propTypes.string,
  scriptOptionsIsOpen: propTypes.bool.isRequired,
  seedSummary: propTypes.array,
  showPrimaryFlag: propTypes.bool.isRequired
};

PlantingScriptCardContainer = connect(
  // mapStateToProps
  (state, ownProps) => {
    const script = ownProps.script;
    const scriptId = script.id;

    return {
      accountCountry: getAccountCountry(state),
      bagSize: getBagSizeForCrop(state, getCropForScript(script)),
      canManualScript: canManualScript(state),
      cropId: getCropIdForScript(state, script),
      isAdvancedScript: isAdvancedScript(script),
      isSelected: getActiveScriptId(state) === scriptId,
      onSelectScript: ownProps.onSelectScript,
      productValidationValues: getProductValidationValues(state),
      script: script,
      scriptId: scriptId,
      scriptOptionsIsOpen: scriptOptionsIsOpenForScriptId(state, scriptId),
      seedSummary: getManageSeedSummary(script, { bagSize: getBagSizeForScript(state, script) }),
      showPrimaryFlag: isDisplayPrimaryScript(state, script)
    };
  },
  (dispatch, ownProps) => {
    return {
      onClickEditTrigger: ({ scriptId, uiLocation }) => {
        dispatch(editScript({ scriptId, uiLocation }));
      },
      onClickScriptOptionsTrigger: ({ scriptId, currentStatus }) => {
        ownProps.onSelectScript(scriptId);
        dispatch(requestPreferredDevice());
        dispatch(requestDriveDevices());
        dispatch(requestAffiliateList());
        dispatch(setScriptOptionsIsOpen({ scriptId, status: !currentStatus }));
      }
    };
  }
)(PlantingScriptCardContainer);

export default PlantingScriptCardContainer;
